const openSessionList = (state) => state.openSessionList;
const selectedSessionData = (state) => state.selectedSessionData;
const outlierSessionData = (state) => state.outlierSessionData;
const incompleteData = (state) => state.incompleteData;
const completedSessionData = (state) => state.completedSessionData;
const completedSessionLots = (state) => state.completedSessionLots;
const commonConsumptionHistory = (state) => state.commonConsumptionHistory;
const adhocSessionData = (state) => state.adhocSessionData;
const adhocSessionLots = (state) => state.adhocSessionLots;
const billValue = (state) => state.billValue;
const completeSessionDownloadStatus = (state) => state.completeSessionDownloadData;
const totalBillableUnits = (state) => state.totalBillableUnits;
const suspiciousMessages = (state) => state.suspiciousMessages;


export default {
  openSessionList,
  selectedSessionData,
  totalBillableUnits,
  outlierSessionData,
  incompleteData,
  completedSessionData,
  completedSessionLots,
  commonConsumptionHistory,
  adhocSessionData,
  adhocSessionLots,
  billValue,
  completeSessionDownloadStatus,
  suspiciousMessages
}



// WEBPACK FOOTER //
// ./src/store/modules/sessions/getters.js